<template>
	<div class="container-fluid">
		<div class="row mt-2 mb-4">
			<div class="col-sm-12 text-right">
				<h1>Valuadores</h1>
			</div>
		</div>

		<div v-if="solicitudes.length > 0" class="d-flex flex-wrap card-solicitud"> 
			<div v-for="solicitud in solicitudes" :key="solicitud.id" class="col-md-4">
				<div class="card">
					<h4 class="card-title text-center">
						<span>Solicitud: </span>
						<span>{{ solicitud.solicitud }}</span>
					</h4>
					<div class="card-body">
							<div class="d-flex justify-content-between align-items-end list-item">
							<span class="col">Cita</span>
							<span class="col text-right"> {{ validarDatos(solicitud,"fecha_cita") }} </span>
						</div>

						<div class="d-flex justify-content-between align-items-end list-item mb-4">
							<span class="col">Carga de valuación</span>
							<span class="col text-right"> {{ validarDatos(solicitud,"evaluacion") }} </span>
						</div>
						<div>
							<router-link :to="{name: 'formalizacion_avaluo_solicitud', params:{solicitud: solicitud.solicitud }}" class="btn complementary-btn">Ver solicitud</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-else class="row mt-4">
			<div class="col-sm-12 text-center">No tienes solicitudes pendientes asignadas</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import api from '@/apps/formalizacion/api/v1/formalizacion'

	export default {

		data: function() {
			return {
				solicitudes: []
			}
		}
		,mounted: function() {
			this.obtenerSolicitudes();
		}

		,methods: {
			obtenerSolicitudes: async function() {
				try {
					this.solicitudes = (await api.obtenerSolicitudes(2)).data;
				}catch(e) {
					this.$log.info('error', e);
					this.$helper.showAxiosError(e, 'Error');
				}
			}
			,validarDatos: function(data, col) {
				// this.$log.info('data', data);
				let tmpObj = new Object()

				if (data.sla && data.sla.length > 0) {
					data.sla.forEach(evento => {
						tmpObj[evento.tipo] = evento.created_at;
					});
				}

				// this.$log.info('steps', tmpObj);

				return Object.keys(tmpObj).indexOf(col) != -1 ? this.$moment(tmpObj[col]).format('YYYY-MM-DD HH:mm') : 'N/A';
			}
		}

		,watch: {
			options: {
				handler: function(val, oldVal) {
					this.obtenerSolicitudes(this.options);
				}
				,deep: true
			}
		}
	}
</script>

<style lang="scss" scope>
	.card-solicitud {
		.card-title {
			padding: 1rem;
			margin-bottom: 0;
			background-color: #056EAF;
			
			span {
				color: #fff !important;
				font-weight: 700;
			}
		}
	}

	.card-body {
		.list-item {
			padding: .5rem 0;
			&:nth-child(2n+1) {
				background-color: #E6E6E6;
			}

			.text-right {
				font-weight: bolder;
			}
		}
	}
</style>